/* eslint-disable unicorn/filename-case -- TODO rename later */
const LightModeThemeColors = {
  primary: {
    950: "oklch(0.282 0.091 267.935)",
    900: "oklch(0.379 0.146 265.522)",
    800: "oklch(0.424 0.199 265.638)",
    700: "oklch(0.488 0.243 264.376)",
    600: "oklch(0.546 0.245 262.881)",
    500: "oklch(0.623 0.214 259.815)",
    400: "oklch(0.707 0.165 254.624)",
    300: "oklch(0.809 0.105 251.813)",
    200: "oklch(0.882 0.059 254.128)",
    100: "oklch(0.932 0.032 255.585)",
    50: "oklch(0.97 0.014 254.604)",
  },
  secondary: {
    950: "oklch(0.277 0.046 192.524)",
    900: "oklch(0.386 0.063 188.416)",
    800: "oklch(0.437 0.078 188.216)",
    700: "oklch(0.511 0.096 186.391)",
    600: "oklch(0.6 0.118 184.704)",
    500: "oklch(0.704 0.14 182.503)",
    400: "oklch(0.777 0.152 181.912)",
    300: "oklch(0.855 0.138 181.071)",
    200: "oklch(0.91 0.096 180.426)",
    100: "oklch(0.953 0.051 180.801)",
    50: "oklch(0.984 0.014 180.72)",
  },
  gray: {
    50: "oklch(0.985 0.002 247.839)",
    100: "oklch(0.967 0.003 264.542)",
    200: "oklch(0.928 0.006 264.531)",
    300: "oklch(0.872 0.01 258.338)",
    400: "oklch(0.707 0.022 261.325)",
    500: "oklch(0.551 0.027 264.364)",
    600: "oklch(0.446 0.03 256.802)",
    700: "oklch(0.373 0.034 259.733)",
    800: "oklch(0.278 0.033 256.848)",
    900: "oklch(0.21 0.034 264.665)",
    950: "oklch(0.13 0.028 261.692)",
  },
  blue: {
    600: "oklch(0.546 0.245 262.881)",
    500: "oklch(0.623 0.214 259.815)",
    400: "oklch(0.707 0.165 254.624)",
    300: "oklch(0.809 0.105 251.813)",
    200: "oklch(0.882 0.059 254.128)",
    100: "oklch(0.932 0.032 255.585)",
    50: "oklch(0.97 0.014 254.604)",
  },
  green: {
    600: "oklch(0.627 0.194 149.214)",
    500: "oklch(0.723 0.219 149.579)",
    400: "oklch(0.792 0.209 151.711)",
    300: "oklch(0.871 0.15 154.449)",
    200: "oklch(0.925 0.084 155.995)",
    100: "oklch(0.962 0.044 156.743)",
  },
  yellow: {
    600: "oklch(0.681 0.162 75.834)",
    500: "oklch(0.795 0.184 86.047)",
    400: "oklch(0.852 0.199 91.936)",
    300: "oklch(0.905 0.182 98.111)",
    200: "oklch(0.945 0.129 101.54)",
    100: "oklch(0.973 0.071 103.193)",
  },
  red: {
    600: "oklch(0.577 0.245 27.325)",
    500: "oklch(0.637 0.237 25.331)",
    400: "oklch(0.704 0.191 22.216)",
    300: "oklch(0.808 0.114 19.571)",
    200: "oklch(0.885 0.062 18.334)",
    100: "oklch(0.936 0.032 17.717)",
  },
  violet: {
    600: "oklch(0.541 0.281 293.009)",
    500: "oklch(0.606 0.25 292.717)",
    400: "oklch(0.702 0.183 293.541)",
    300: "oklch(0.811 0.111 293.571)",
    200: "oklch(0.894 0.057 293.283)",
    100: "oklch(0.943 0.029 294.588)",
  },
  white: {
    0: "#FFFFFF",
    50: "#ECECEC",
    100: "#E2E2E2",
  },
};

export default LightModeThemeColors;
